export default __webpack_public_path__ + "static/media/fad-ADR.5270d4bf.svg";